import { StoreProvider } from 'easy-peasy'
import React, { FC } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import 'Scss/main.scss'
import { store } from 'Store'
import { Initialization, Logout } from 'TemplateConstants/components'
import reportWebVitals from './reportWebVitals'
import '@fortawesome/fontawesome-pro/css/all.min.css';
import { useAppInitializer } from 'Components/app/AppInitializer'

const app = React.lazy(async () => await import('Components/app/App').then(module => ({ default: module.default })))

const WrappedApp: FC = () => {
  const { initializeApp } = useAppInitializer()
  return (
    <Router>
      <React.StrictMode>
        <Route exact path='/logout' component={Logout} />
        <Route path='/'>
          <Initialization
            App={app}
            appInitializer={initializeApp}
            loaderProps={{
              contactEmail: 'application-support@mit.edu',
              name: 'Canvas Extended Access',
              exit: false
            }}
          />
        </Route>
      </React.StrictMode>
    </Router>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <WrappedApp />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
